import React, { useState } from "react";
import { Blacked, ModalContent, ModalHeader, ModalInput, ModalSubmit, ModalTitle, ModalWrapper } from "../styles";
import { Icon } from "CRM/organism/Main/styles";
import { FaChevronLeft } from "react-icons/fa6";
import { Input, Select, message } from "antd";
import API from "utils/api";
import { useToken } from "app/hooks";
import { useBranchList } from "CRM/hooks/GetBranchList";
import { useTeamList } from "../../hooks/GetTeamList";
import { useIsMobile } from "../IsMobile";

export const TeamAdd = ({ setIsAdd }) => {
	const IsMobile = useIsMobile();
	const { data: token } = useToken();
	const { mutate } = useTeamList();
	const { branchList } = useBranchList();
	const [branchId, setBranchId] = useState<null | number>(null);
	const [name, setName] = useState("");
	const [desc, setDesc] = useState("");

	const clickSubmit = () => {
		const shouldEdit = window.confirm(`등록하실 내용이 맞습니까? \n 플랫폼: ${name} \n 설명: ${desc}`);
		if (shouldEdit) {
			if (branchId == 0) {
				message.error("지사를 선택해주세요");
				return;
			}
			if (name == "") {
				message.error("팀명은 필수 입력입니다.");
			} else {
				API.post("/team", token + "", {
					branchId: branchId,
					name: name,
					desc: desc,
				})
					.then((res: any) => {
						if (res.result.success) {
							message.success("추가되었습니다");
							mutate();
							setIsAdd(false);
						}
					})
					.catch((err: any) => {});
			}
		}
	};

	return (
		<>
			<Blacked onClick={() => setIsAdd(false)} />
			<ModalWrapper IsMobile={IsMobile}>
				<ModalHeader>
					<Icon onClick={() => setIsAdd(false)}>
						<FaChevronLeft />
					</Icon>
					<ModalTitle>팀 추가</ModalTitle>
					<ModalSubmit onClick={clickSubmit}>저장</ModalSubmit>
				</ModalHeader>
				<ModalContent>
					<Select value={branchId === null ? null : +branchId} onChange={(e) => setBranchId(e)}>
						<label htmlFor="branch">지사명 *</label>
						{process.env.REACT_APP_API_URL?.includes("ccl") && (
							<option
								style={{
									fontFamily: "Pretendard",
								}}
								value={1}
							>
								본사
							</option>
						)}

						{branchList?.map((it) => (
							<option
								style={{
									fontFamily: "Pretendard",
								}}
								value={+it.id}
							>
								{it.name}
							</option>
						))}
					</Select>
					<ModalInput>
						<label htmlFor="name">팀명 *</label>
						<Input
							id="name"
							type="text"
							value={name}
							onChange={(e) => setName(e.target.value)}
							placeholder="상태를 입력해주세요."
						/>
					</ModalInput>
					<ModalInput>
						<label htmlFor="desc">설명</label>
						<Input
							id="desc"
							type="text"
							value={desc}
							onChange={(e) => setDesc(e.target.value)}
							placeholder="설명을 입력해주세요."
						/>
					</ModalInput>
				</ModalContent>
			</ModalWrapper>
		</>
	);
};

export default React.memo(TeamAdd);
